module.exports = __webpack_public_path__ + "static/media/shape-L.a4c44d11.svg";